/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useLocation } from 'react-router-dom';

export default function Home() {
  const location = useLocation();

  return (
    <>
      { (location.pathname !== "/") &&
        <div className="alert alert-warning" role="alert">
          Please connect for the menu to work and see the selected page. Showing front page until then.
        </div>
      }
       <h1 className="display-4">reBURN Protocol</h1>

       <p className="lead">
       reBURN Protocol helps you create your own token. Your very special kind of token: one that recycles burned tokens.
       </p>

    <div className="row">
    <div className="col-lg-6 col-sm-12">

    <h2>How it works</h2>
    <ol className="lead">
      <li>Say you have a token you like, eg. KITTY, which burns or burned many tokens.
      <br/>
      It's a shame those burned tokens are forever lost.
      </li>
      <li>You create a new token which tracks the burn address of KITTY. You name it, let's say, reKITTY.
      </li>
      <li>reKITTY is a fully functional token. The reKITTY smart contract balance will grow📈 in sync with KITTY burn rate and all the new reKITTY goes to your treasury account.
      </li>
      <li>To keep things interesting you can incentivize liquidity providers by rewarding them with tokens from the treasury.
      </li>
      <li>
      All burned tokens get to live again! It's a miracle.
      </li>
    </ol>

    <p className="lead">
          Tokens like reKITTY have no fees: transferring them has the normal gas cost.
    </p>
    </div>
    <div className="col-lg-6 col-sm-12">
       <img src="reburn-explanation.png" alt="reBurn flowchart" className="img-fluid"/>
    </div>
    </div>
    </>
  );
}